/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable no-global-assign */
/* eslint-disable @typescript-eslint/no-explicit-any */
// workaround pass NEXT_PUBLIC_ varables via server side props.
// https://nextjs.org/docs/pages/building-your-application/configuring/environment-variables
// NextJS inlines (In order to make the value of an environment variable accessible in the browser, Next.js can "inline" a value, at build time).
// but variables are not available during build time in ci pipeline.

export const publicEnv = {
  NEXT_PUBLIC_NODE_ENV: process.env.NEXT_PUBLIC_NODE_ENV || null,
  NEXT_PUBLIC_APP_ENV: process.env.NEXT_PUBLIC_APP_ENV || null,
  NEXT_PUBLIC_ANALYTICS_ID: process.env.NEXT_PUBLIC_ANALYTICS_ID || null,
  NEXT_PUBLIC_DESCOPE_STAGING_PROJECT_ID: process.env.NEXT_PUBLIC_DESCOPE_STAGING_PROJECT_ID || null,
  NEXT_PUBLIC_DESCOPE_STAGING_FLOW_ID: process.env.NEXT_PUBLIC_DESCOPE_STAGING_FLOW_ID || null,
  NEXT_PUBLIC_DESCOPE_US_PROJECT_ID: process.env.NEXT_PUBLIC_DESCOPE_US_PROJECT_ID || null,
  NEXT_PUBLIC_DESCOPE_US_FLOW_ID: process.env.NEXT_PUBLIC_DESCOPE_US_FLOW_ID || null,
  NEXT_PUBLIC_DESCOPE_EU_PROJECT_ID: process.env.NEXT_PUBLIC_DESCOPE_EU_PROJECT_ID || null,
  NEXT_PUBLIC_DESCOPE_EU_FLOW_ID: process.env.NEXT_PUBLIC_DESCOPE_EU_FLOW_ID || null,
  NEXT_PUBLIC_DESCOPE_CA_PROJECT_ID: process.env.NEXT_PUBLIC_DESCOPE_CA_PROJECT_ID || null,
  NEXT_PUBLIC_DESCOPE_CA_FLOW_ID: process.env.NEXT_PUBLIC_DESCOPE_CA_FLOW_ID || null,
  NEXT_PUBLIC_FINGERPRINT_API_KEY: process.env.NEXT_PUBLIC_FINGERPRINT_API_KEY || null,
  NEXT_PUBLIC_AMPLITUDE_API_KEY: process.env.NEXT_PUBLIC_AMPLITUDE_API_KEY || null,
  NEXT_PUBLIC_HOST_URL: process.env.NEXT_PUBLIC_HOST_URL || null,
  NEXT_PUBLIC_GATEWAY_URL: process.env.NEXT_PUBLIC_GATEWAY_URL || null,
  NEXT_PUBLIC_ENGAGE_REALTIME: process.env.NEXT_PUBLIC_ENGAGE_REALTIME || null,
  NEXT_PUBLIC_DATADOG_APPLICATION_ID: process.env.NEXT_PUBLIC_DATADOG_APPLICATION_ID || null,
  NEXT_PUBLIC_DATADOG_CLIENT_TOKEN: process.env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN || null,
  NEXT_PUBLIC_VERSION: process.env.NEXT_PUBLIC_VERSION || '',
  NEXT_PUBLIC_EQUALWEB_SITEKEY: process.env.NEXT_PUBLIC_EQUALWEB_SITEKEY || null,
};
export const setPublicEnvAsGlobal = (envVars: any) => {
  globalThis.process = globalThis.process || {};
  globalThis.process.env = globalThis.process.env || {};
  Object.keys(envVars).forEach((key) => {
    if (typeof envVars[key] === 'string') {
      globalThis.process.env[key] = envVars[key];
    }
  });
};
